const HAWAII_SP_BOOKING_BASE = 'https://explore.ehawaii.gov/web/';

/**
 * Explore Outdoor Hawaiʻi facility deeplink (park + facility path only).
 * Date and party-size query params are not honored on the camping flow.
 */
export function buildHawaiiSpBookingUrl({ parkPlaceId, facilityId }) {
  if (parkPlaceId == null || facilityId == null) {
    return 'https://explore.ehawaii.gov';
  }
  return `${HAWAII_SP_BOOKING_BASE}#!park/${parkPlaceId}/${facilityId}`;
}

export function buildHawaiiSpBookingUrlForOuting({ outing }) {
  if (!outing) return 'https://explore.ehawaii.gov';
  return buildHawaiiSpBookingUrl({
    parkPlaceId: outing.parent_id,
    facilityId: outing.entity_id,
  });
}
